<template>
  <tr>
    <td colspan="99" class="pa-0">
      <v-sheet color="alternate" class="px-8 py-5">
        <div class="mb-2">
          <h3>
            {{
              $t(
                "people:ShoppingBasketPage.TransactionsHistoryTab.table.heading.Details.label",
                "Details"
              )
            }}
          </h3>

          <PaymentHistoryDetails :payment="item" />
        </div>

        <div v-if="item.status == 'PENDING'">
          <v-divider class="my-3" />
          <!-- 
          <v-tooltip
            v-if="$allowedMutation(item.allowedMutations, 'paymentCancel')"
            bottom
          >
            <template #activator="{on, attrs}">
              <v-btn
                v-if="$allowedMutation(item.allowedMutations, 'paymentConfirm')"
                icon
                v-bind="attrs"
                small
                :aria-label="
                  $t(
                    'people:ShoppingBasket.TransactionHistory.confirmPaymentButton.alt'
                  )
                "
                :disabled="mutationLoading"
                class="edit-green mb-1"
                v-on="on"
                @click="$emit('confirm', { item: item, evt: $event })"
              >
                <v-icon color="white" small>$iconCheck</v-icon>
                <v-progress-circular
                  v-show="false"
                  color="white"
                  size="21"
                  indeterminate
                />
              </v-btn>
            </template>
            {{
              $t(
                "people:ShoppingBasket.TransactionHistory.ConfirmPaymentButton.label",
                "Confirm payment",
                "Label of confirm payment button in Transaction History tab"
              )
            }}
          </v-tooltip>
-->
          <v-tooltip
            v-if="$allowedMutation(item.allowedMutations, 'paymentCancel')"
            bottom
          >
            <template #activator="{on, attrs}">
              <v-btn
                icon
                small
                v-bind="attrs"
                class="remove mb-1"
                :aria-label="
                  $t(
                    'people:ShoppingBasket.TransactionHistory.cancelPaymentButton.alt'
                  )
                "
                :disabled="mutationLoading"
                v-on="on"
                @click="$emit('cancel', { item: item, evt: $event })"
              >
                <v-icon color="white" small>$iconTimesCircle</v-icon>
                <v-progress-circular
                  v-show="false"
                  color="white"
                  size="21"
                  indeterminate
                />
              </v-btn>
            </template>
            {{
              $t(
                "people:ShoppingBasket.TransactionHistory.CancelPaymentButton.label",
                "Cancel payment",
                "Label of cancel payment button in Transaction History tab"
              )
            }}
          </v-tooltip>
        </div>
        <template v-if="item.receipts && item.receipts.length > 0">
          <v-divider class="my-3" />
          <div class="text-right px-5">
            <AppReceiptLink
              v-for="receipt in item.receipts"
              :key="receipt.id"
              :receipt="receipt"
              :receipt-status="item.receiptsStatus"
              large
            />
          </div>
        </template>
      </v-sheet>
    </td>
  </tr>
</template>
<script>
import PaymentHistory from "./PaymentHistory.vue";
export default {
  name: "ExpandedPaymentHistory",
  mixins: [PaymentHistory]
};
</script>
